import { TextField } from '@material-ui/core';
import { padStart } from 'lodash';
import React from 'react';

const toHHmm = (value: number) => `${padStart(value + '', 2, '0')}:00`;
const fromHHmm = (value: string) => parseInt(value.split(':')[0], 10);

export const SelectHour: React.FC<{
  value: number;
  onChange: (nextValue: number) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled }) => {
  return (
    <TextField
      type="time"
      value={toHHmm(value)}
      inputProps={{
        // Defaulting to the normal step duration of one minute when disabled
        // fixes a minor rendering/coloring bug with this component
        step: disabled ? 60 : 60 * 60 // 60 min
      }}
      onChange={(ev) => onChange(fromHHmm(ev.target.value))}
      disabled={disabled}
    />
  );
};
